export default "__VITE_ASSET__BJTbqVIN__"